<template>
  <v-card flat tile>
    <v-card-title>Current Investments</v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="investments"
        class="mb-12 elevation-1"
        no-data-text="You have no current investments."
      >
        <template v-slot:item.mainImage="{ item }">
          <v-img
            max-width="100px"
            class="my-1"
            :src="parseImage(item.images)"
          ></v-img>
        </template>

        <!-- Custom Processing for Specific Items -->
        <template v-slot:item.title="{ item }">
          <router-link :to="`/flip/${item.id}`">
            {{ item.title }}
          </router-link>
        </template>

        <template v-slot:item.percFunded="{ item }">
          {{ calcFunded(item.sharesForSale, item.totalShares) }}%
        </template>

        <template v-slot:item.metadata.projectedRoi="{ item }">
          {{ item.metadata.projectedRoi }}% ROI
        </template>

        <template v-slot:item.auctionStartTimestamp="{ item }">
          <a v-bind:href="`${item.auctionLink}`" target="_blank">
             {{ item.auctionStartTimestamp | timestampToDate }}
          </a>
        </template>

        <!-- <template v-slot:item.buyItNowPrice="{ item }">
          {{ item.buyItNowPrice | numberToMoney }}
        </template> -->
      </v-data-table>
    </v-card-text>

  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'CurrentInvestments',

    components: {
    },

    props: {
      userId: Number
    },

    computed: {
      ...mapGetters([
        'adminUserViewCurrentInvestments',
        'currentInvestments'
      ])
    },

    data: () => ({
      investments: [],

      headers: [
        {
          text: '',
          value: 'mainImage'
        },
        {
          text: 'Asset',
          value: 'title'
        },
        {
          text: 'Shares Owned',
          value: 'sharesOwned'
        },
        {
          text: '% Funded',
          value: 'percFunded'
        },
        {
          text: 'Projected ROI',
          value: 'metadata.projectedRoi'
        },
        {
          text: 'Auction Date',
          value: 'auctionStartTimestamp'
        }
        // ,
        // {
        //   text: 'Buy It Now Price',
        //   value: 'buyItNowPrice'
        // }
      ]
    }),

    methods: {
      ...mapActions([
        'getCurrentInvestments',
        'adminGetCurrentInvestments'
      ]),

      calcFunded: function(avail, tot) {
        let fundedPerc = ((tot - avail) / tot) * 100

        return Math.round(fundedPerc)
      },

      // Parse out the small main image.
      parseImage: function(images) {
        if (images.length > 0) {
          return images.find(i => i.type === 'mainImage').smallUri
        }
        return ''
      }
    },

    async created() {
      // Admin viewing a user.
      if (this.userId) {
        await this.adminGetCurrentInvestments(this.userId).then(() => {
          this.investments = this.adminUserViewCurrentInvestments
        })
      }
      // User viewing their account.
      else {
        await this.getCurrentInvestments().then(() => {
          this.investments = this.currentInvestments
        })
      }
    }
  }
</script>
